import Client from './client.service';
import { contact } from '@config/config';

class Contact extends Client {
  static path = contact;

  static url = (path) => {
    return this.api_url + this.api_url_prefix + path;
  };

  static get_contact = async (page = 1, pagesize = 100, params = {}) => {
    const url = `${this.url(this.path.GET)}?${this._query_string({ slug: 'contact', page, pagesize, ...params })}`;
    return this._fetch(url);
  };
}

export default Contact;
